export default {
  displayXL: {
    "font-size": 60,
    "line-height": 60,
    mq: {
      lg: {
        "font-size": 112,
        "line-height": 112,
      }
    }
  },
  displayLG: {
    "font-size": 48,
    "line-height": 48,
    mq: {
      lg: {
        "font-size": 56,
        "line-height": 56,
      }
    }
  },
  displayMD: {
    "font-size": 36,
    "line-height": 36,
    mq: {
      lg: {
        "font-size": 48,
        "line-height": 48,
      }
    }
  },
  displaySM: {
    "font-size": 28,
    "line-height": 28,
    mq: {
      lg: {
        "font-size": 36,
        "line-height": 36,
      }
    }
  },
  displayXS: {
    "font-size": 22,
    "line-height": 22,
    mq: {
      lg: {
        "font-size": 28,
        "line-height": 28,
      }
    }
  },
  headingXXL: {
    "font-size": 40,
    "line-height": 48,
    mq: {
      lg: {
        "font-size": 56,
        "line-height": 56,
      }
    }
  },
  headingXL: {
    "font-size": 32,
    "line-height": 40,
    mq: {
      lg: {
        "font-size": 44,
        "line-height": 48,
      }
    }
  },
  headingLG: {
    "font-size": 28,
    "line-height": 32,
    mq: {
      lg: {
        "font-size": 36,
        "line-height": 46,
      }
    }
  },
  headingMD: {
    "font-size": 24,
    "line-height": 28,
    mq: {
      lg: {
        "font-size": 32,
        "line-height": 40,
      }
    }
  },
  headingSM: {
    "font-size": 20,
    "line-height": 28,
    mq: {
      lg: {
        "font-size": 24,
        "line-height": 32,
      }
    }
  },
  headingXS: {
    "font-size": 16,
    "line-height": 24,
    mq: {
      lg: {
        "font-size": 20,
        "line-height": 26,
      }
    }
  },
  paragraphLG: {
    "font-size": 16,
    "line-height": 24,
    mq: {
      lg: {
        "font-size": 18,
        "line-height": 26,
      }
    }
  },
  paragraphMD: {
    "font-size": 14,
    "line-height": 20,
    mq: {
      lg: {
        "font-size": 16,
        "line-height": 24,
      }
    }
  },
  paragraphSM: {
    "font-size": 12,
    "line-height": 16,
    mq: {
      lg: {
        "font-size": 14,
        "line-height": 20,
      }
    }
  },
  paragraphXS: {
    "font-size": 10,
    "line-height": 14,
    mq: {
      lg: {
        "font-size": 12,
        "line-height": 16,
      }
    }
  },
  label: {
    "font-size": 10,
    "line-height": 16,
    "letter-spacing": '0.04em',
    mq: {
      lg: {
        "font-size": 14,
        "line-height": 18,
        "letter-spacing": '0.04em',
      }
    }
  },
  linkMD: {
    "font-size": 16,
    "line-height": 24,
  },
  linkSM: {
    "font-size": 14,
    "line-height": 20,
  },
  buttonMD: {
    "font-size": 16,
    "line-height": 24,
  },
  buttonSM: {
    "font-size": 14,
    "line-height": 20,
  },
}
